<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="530"
           :class-name="z100000"
    >
      <h3 slot="header" class="modal-header">添加管辖范围</h3>
      <div class="content mb16 noselected"  style="margin: 0 auto;">
        <Input placeholder="搜索 " @on-change="setTreeData"
               v-model="searchText"
        />
        <Tree :data="treeData" :multiple="true" show-checkbox ref="tree"></Tree>
      </div>
    </Modal>
  </div>

</template>
<script>
  import {getConfigDataAuth, bindDataAuth } from "../../../../api/user";
  import {setTitleCheckedAndLevel, setCheckedFromData, filterArr} from "../../js/systemmanage";
  export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      extentUid:{
        type:String,
        default:''
      },
    },
    watch:{
      n(){
        this.treeData = [];
        this.searchText = '';
        this.appType = 3;
        this.extentTree();
        this.isShow=true
      }
    },
    data(){
      return {
        z100000:'z100000',
        loading: true,
        isShow:false,
        appType:3,
        treeData: [],
        data: [],
        searchText: '',
        appTypeList:[{text:'自如寓后台',value:1},{text:'超级ZO',value:2},{text:'一三环境',value:3}],
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      extentTree() {
        return getConfigDataAuth({uid:this.extentUid,appType:this.appType}).then(res => {
          if (!(res.data && res.data.operatorDataAuth.length > 0)) {
            return
          }
          let data = res.data.operatorDataAuth;
          setTitleCheckedAndLevel(data, 1);
          if (res.data.userDataAuthIds.length > 0) {
            setCheckedFromData(data, res.data.userDataAuthIds)
          }
          this.data = data;
          this.treeData = this.data
        }).catch(error => {
        })
      },
      setTreeData: function () {
        if (!this.searchText) {
          this.treeData = this.data
        }
        else {
          this.treeData = filterArr(this.data, this.searchText)
        }
      },
      ok(){
        let checked = this.$refs['tree'].getCheckedNodes();
        let levelOneArr = [];
        let dataArr = {
          cityAuth: [],
          // projectAuth: [],
          areaAuth: [],
          uid:this.extentUid,
          appType:this.appType
        };
        function getChecked(data) {
          data.forEach(ele=>{
            if(ele.checked){
              if(ele.parentValue === '0'){
                levelOneArr.push(ele.value)
              }else {
                levelOneArr.push(ele.parentValue);
                // dataArr.projectAuth.push(ele.value)
                dataArr.areaAuth.push(ele.value)
              }
            }
          })
        }
        getChecked(checked);
        let json = {};
        for (let i = 0; i < levelOneArr.length; i++) {
          if (!json[levelOneArr[i]]) {
            dataArr.cityAuth.push(levelOneArr[i]);
            json[levelOneArr[i]] = 1;
          }
        }
        bindDataAuth(dataArr).then(res=>{
          this.$Message.success('添加管辖范围成功')
        }).catch(error=>{

        }).finally(()=>{
          this.isShow=false
        })
      },
      cancel(){
        this.isShow = false
      }
    }

  }
</script>

<style scoped>
  .content{
    height: 350px;
    overflow: auto;
    border: 1px solid #dcdcdc;
    width: 330px;
    padding: 10px;
    box-sizing: border-box;
    /*margin: 0 auto;*/
    /*padding-left: 30px;*/

  }
  .left,.right{
    height: 100%;
    overflow: auto;
  }
  .left{
    width: 200px;
    /*background: lightgray;*/
    border: 1px solid #dcdcdc;
    padding: 10px;
    box-sizing: border-box;
    margin-right: 20px;
  }

</style>
